import React, { useEffect, useMemo, useState } from "react";
import { useAutoScroll } from "./autoscroll";
import AutoScroll from "embla-carousel-auto-scroll";
import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselOptions,
} from "../@shadcn/components/ui/carousel";

type PropType = {
  slides: React.ReactNode[];
  options?: CarouselOptions;
  styles?: {
    button?: {
      backgroundColor?: string;
    };
  };
};

export const Marquee: React.FC<PropType> = (props) => {
  const { slides } = props;
  const [api, setApi] = useState<CarouselApi>();

  const autoplayPlugin = React.useRef(
    AutoScroll({
      playOnInit: true,
      speed: 1,
    })
  );

  const { resumeAutoScroll, stopAutoScroll } = useAutoScroll(api);

  useEffect(() => {
    resumeAutoScroll();
    return () => {
      stopAutoScroll();
    };
  }, [resumeAutoScroll, stopAutoScroll]);

  const duplicateSlides = useMemo(() => {
    if (slides.length > 4) return slides;
    return [...slides, ...slides, ...slides, ...slides];
  }, [slides]);

  if (!slides.length) return null;

  return (
    <section className="embla ui-relative ui-mx-auto">
      <Carousel
        opts={{ loop: true }}
        plugins={[autoplayPlugin.current]}
        setApi={setApi}
      >
        <CarouselContent className="ui-touch-pan-y -ui-ml-0">
          {duplicateSlides.map((slide, index) => (
            <div
              className="ui-flex-[0_0_auto] ui-min-w-0 ui-transform ui-translate-x-0 ui-translate-y-0 ui-translate-z-0 ui-pl-0"
              key={index}
            >
              <div className="">{slide}</div>
            </div>
          ))}
        </CarouselContent>
      </Carousel>
    </section>
  );
};
